// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import server from './utils/request'
import 'element-ui/lib/theme-chalk/index.css';
import { Upload, Message, Table, Button, TableColumn, Dialog,Pagination,Input,Radio,Checkbox,MessageBox } from 'element-ui';
import AWS from 'aws-sdk';
import { formatTime,formatDate  } from './utils/index'
Vue.prototype.$axios = server;
Vue.config.productionTip = false

Vue.component(Upload.name, Upload);
Vue.component(Message.name, Message);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Button.name, Button);
Vue.component(Dialog.name, Dialog);
Vue.component(Pagination.name, Pagination);
Vue.component(Input.name, Input);
Vue.component(Radio.name, Radio);
Vue.component(Checkbox.name, Checkbox);
Vue.component(MessageBox.name, MessageBox);
Vue.prototype.$Message = Message;
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$confirm  = MessageBox.confirm;
Vue.prototype.AWS = AWS
Vue.prototype.S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
Vue.prototype.guid = function() {
    return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
};


Vue.filter('createTime', function(value) {
    if (!value) return ''
    value = formatTime(value);
    return value;
});
Vue.filter('formatDate', function(value) {
    if (!value) return ''
    value = formatDate(value,3);
    return value;
});
Vue.filter('songSize', function(value) {
    if (!value) return '';
    value = (Number(value) / 1024 / 1024).toFixed(2) + 'MB';
    return value;
});
Vue.filter('toFixed', function(value,num=2) {
    value = Number(value).toFixed(num);
    value=value?value:'0.00';
    return value;
});
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js